var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"332af4f47895b15241e11490cd71d9f422d6bcc7"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["docupet-app-store@docupet"]={id:"332af4f47895b15241e11490cd71d9f422d6bcc7"};
      